import React from "react";
import Lottie from "lottie-react";
import { WeatherIconProps } from "./types";
import { Weather } from "../../types/variables/Variables";
import { rain, partly_rain, partly_cloudy, thunderstorm, severe_thunderstorm, cloudy, sunny, cloudy2 } from "../../assets/animations";

export const WeatherIcon: React.FC<WeatherIconProps> = ({ weather }) => {
    switch (weather?.toLowerCase()) {
        case Weather.SUNNY:
            return <Lottie style={{}} animationData={sunny} loop={true} />

        case Weather.CLOUDY:
        case Weather.FOGGY:
            return <Lottie style={{}} animationData={cloudy2} loop={true} />

        case Weather.PARTLY_CLOUDY:
            return <Lottie style={{}} animationData={partly_cloudy} loop={true} />

        case Weather.RAINY:
            return <Lottie style={{}} animationData={rain} loop={true} />

        case Weather.PARTLY_RAINY:
            return <Lottie style={{}} animationData={partly_rain} loop={true} />

        case Weather.STORMY:
            return <Lottie style={{}} animationData={thunderstorm} loop={true} />

        case Weather.THUNDERSTORM:
            return <Lottie style={{}} animationData={severe_thunderstorm} loop={true} />


        default:
            return <Lottie style={{}} animationData={sunny} loop={true} />
    }
};